import dayjs from 'dayjs';

export const getTimeStamp = () => {
  const time = dayjs().format('mm:ss:SSS');

  return `${time}`;
};

export const getUnix = () => {
  const time = dayjs().unix();

  return time;
};

export const getUnixMilliSeconds = () => {
  const time = Date.now();

  return time;
};

export const getOneYearAgoTimestamp = () => {
  const current = new Date().getTime();
  const oneYearAgo = current - 365 * 24 * 60 * 60 * 1000;

  return {
    current,
    oneYearAgo,
  };
};
